import { useDisplay } from 'vuetify';
import { TripPatternDetailsMobile } from '@/features/trips/components';
import { useTripSearchStore } from '@/features/trips/stores';
import { storeToRefs } from 'pinia';

export function setupTripSearchDetails() {
    const { mobile: isMobile } = useDisplay();
    const tripSearchStore = useTripSearchStore();
    const { searchResult, selectedTripPattern, selectedTripPatternId, selectedTripPatternIdIsExpanded } = storeToRefs(tripSearchStore);

    function goBackToList() {
        // if mobile, reset all
        if (isMobile.value) {
            selectedTripPatternId.value = null;
        }

        selectedTripPatternIdIsExpanded.value = false;
    }

    return {
        searchResult,
        selectedTripPattern,
        selectedTripPatternId,
        selectedTripPatternIdIsExpanded,
        tripPatternDetailsComponent: TripPatternDetailsMobile,
        goBackToList
    };
}
